import type { PeriodMaster } from '@dcc-erp/shared';

import { periodFromDate } from './jvImport';

export function openPeriods(periods: PeriodMaster[]): PeriodMaster[] {
  return periods.filter((p) => p.status === 'OPEN');
}

export function findPeriod(periods: PeriodMaster[], iso: string): PeriodMaster | undefined {
  const code = periodFromDate(iso);
  if (!code) return undefined;
  return periods.find((p) => p.period === code);
}

export function isDateInOpenPeriod(periods: PeriodMaster[], iso: string): boolean {
  const p = findPeriod(periods, iso);
  return !!p && p.status === 'OPEN';
}

function firstDayOf(code: string): string {
  return `${code.slice(0, 4)}-${code.slice(4, 6)}-01`;
}

function lastDayOf(code: string): string {
  const y = Number(code.slice(0, 4));
  const m = Number(code.slice(4, 6));
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${code.slice(0, 4)}-${code.slice(4, 6)}-${String(last).padStart(2, '0')}`;
}

// `open` MUST already be filtered to OPEN status (e.g. via openPeriods) — this
// returns the raw min/max span of whatever it is given and does not filter.
export function dateBounds(open: PeriodMaster[]): { min: string; max: string } | null {
  const codes = open.map((p) => p.period).sort();
  const first = codes[0];
  const last = codes[codes.length - 1];
  if (!first || !last) return null;
  return { min: firstDayOf(first), max: lastDayOf(last) };
}

export function defaultVoucherDate(periods: PeriodMaster[], todayIso: string): string {
  if (isDateInOpenPeriod(periods, todayIso)) return todayIso;
  const codes = openPeriods(periods)
    .map((p) => p.period)
    .sort();
  const last = codes[codes.length - 1];
  return last ? lastDayOf(last) : todayIso;
}
